<template>
  <div class="tooltip-container" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
    <span class="tooltip-trigger">
      <svg class="tooltip-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 2.5C8.51664 2.5 7.0666 2.93987 5.83323 3.76398C4.59986 4.58809 3.63856 5.75943 3.07091 7.12987C2.50325 8.50032 2.35472 10.0083 2.64411 11.4632C2.9335 12.918 3.64781 14.2544 4.6967 15.3033C5.7456 16.3522 7.08197 17.0665 8.53683 17.3559C9.99168 17.6453 11.4997 17.4968 12.8701 16.9291C14.2406 16.3614 15.4119 15.4001 16.236 14.1668C17.0601 12.9334 17.5 11.4834 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5Z" stroke="#646464" stroke-width="1.25" stroke-miterlimit="10"/>
        <path d="M7.8125 7.90194C7.8125 7.90194 7.84531 7.21835 8.57695 6.62968C9.01094 6.28007 9.53125 6.1789 10 6.17187C10.427 6.1664 10.8082 6.2371 11.0363 6.34569C11.427 6.53163 12.1875 6.98554 12.1875 7.95077C12.1875 8.9664 11.5234 9.42773 10.7668 9.93515C10.0102 10.4426 9.80469 10.9934 9.80469 11.5625" stroke="#646464" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round"/>
        <path d="M9.76562 14.375C10.1971 14.375 10.5469 14.0252 10.5469 13.5938C10.5469 13.1623 10.1971 12.8125 9.76562 12.8125C9.33415 12.8125 8.98438 13.1623 8.98438 13.5938C8.98438 14.0252 9.33415 14.375 9.76562 14.375Z" fill="#646464"/>
        </svg>
    </span>
    
    <div v-if="showTooltip" class="tooltip-content" :class="position">
      {{ text }}
      <div class="tooltip-arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoTooltip',
  props: {
    text: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'top',
      validator: value => ['top', 'bottom', 'left', 'right'].includes(value)
    }
  },
  data() {
    return {
      showTooltip: false
    }
  }
}
</script>

<style scoped>
/* Tooltip styles moved to src/styles/components/pricing/feature-table.scss */
</style>
